export const SET_POPUP_STATUS = "SET_POPUP_STATUS";
export const SET_MODAL_STATUS = "SET_MODAL_STATUS";
export const SET_DIAGNOSTIC_CONNECTION_STATUS = "SET_DIAGNOSTIC_CONNECTION_STATUS";
export const SET_UNIT_CONNECTION_STATUS = "SET_UNIT_CONNECTION_STATUS";
export const SET_DIAGNOSTIC_CONFIGURATION_FILE  = "SET_DIAGNOSTIC_CONFIGURATION_FILE";
export const SET_LIVE_MONITORING_STREAM_DATA = "SET_LIVE_MONITORING_STREAM_DATA";
export const SET_LIVE_MONITORING_DATA = 'SET_LIVE_MONITORING_DATA';